import { Box } from '@mui/material'
import { DragAndDropFilePicker } from '../../../DragAndDropFilePicker'
import { SurveyFileDisplay } from './SurveyFileDisplay'

interface Props {
  onFileSelect: (file: File | undefined) => void
  onDelete: () => void
  uploadedFileName: string | null | undefined
  uploadedFileKey: string | null | undefined
}

export function SurveyFileUploadArea ({ onFileSelect, onDelete, uploadedFileName, uploadedFileKey }: Props): JSX.Element {
  return (
    <>
      <Box sx={{ mt: 1 }}>
        <DragAndDropFilePicker
          selectFile={onFileSelect}
          accept=".pdf,.jpg,.jpeg,.doc,.xlsx,.csv,.docx"
          useButton
        />
      </Box>
      <SurveyFileDisplay
        fileName={uploadedFileName}
        fileKey={uploadedFileKey}
        onDelete={onDelete}
      />
    </>
  )
}
